// extracted by css-extract-rspack-plugin
export default {"filtersBtn":"FilterButton_filtersBtn__Kpp7b","btnText":"FilterButton_btnText__kONYw","filtersCounter":"FilterButton_filtersCounter__i9TuM"};